import moment from "moment-timezone";
import "moment/dist/locale/ru";

import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);

moment.updateLocale("ru", {
  monthsShort: [
    "янв",
    "фев",
    "мар",
    "апр",
    "мая",
    "июн",
    "июл",
    "авг",
    "сен",
    "окт",
    "ноя",
    "дек",
  ],

  durationLabelsStandard: {
    S: "милисекунда",
    SS: "милисекунды",
    SSS: "милисекунд",
    m: "минута",
    mm: "минуты",
    mmm: "минут",
    h: "час",
    hh: "часа",
    hhh: "часов",
    d: "день",
    dd: "дня",
    ddd: "дней",
    w: "неделя",
    ww: "недели",
    www: "недель",
    M: "месяц",
    MM: "месяца",
    MMM: "месяцев",
    y: "год",
    yy: "года",
    yyy: "лет",
  },

  durationTimeTemplates: {
    HMS: "h:mm:ss",
    HM: "h:mm",
    MS: "m:ss",
  },

  durationPluralKey: function (token, integerValue, decimalValue) {
    // Decimal value does not affect unit label for this locale.

    // "xxx" for > 2.
    if (integerValue > 4) {
      return token + token + token;
    }

    // "x" for === 1.
    if (integerValue === 1) {
      return token;
    }

    if (integerValue === 0) {
      return token + token + token;
    }

    // "xx" for others.
    return token + token;
  },

  calendar: {
    sameDay: "[Сегодня]",
    nextDay: "[Завтра]",
    lastDay: "[Вчера]",
    nextWeek: function (now) {
      if (now.week() !== this.week()) {
        switch (this.day()) {
          case 0:
            return "[В следующее] dddd, [в] LT";
          case 1:
          case 2:
          case 4:
            return "[В следующий] dddd, [в] LT";
          case 3:
          case 5:
          case 6:
            return "[В следующую] dddd, [в] LT";
        }
      } else {
        if (this.day() === 2) {
          return "[Во] dddd, [в] LT";
        } else {
          return "[В] dddd, [в] LT";
        }
      }
    },
    lastWeek: function (now) {
      if (now.week() !== this.week()) {
        switch (this.day()) {
          case 0:
            return "[В прошлое] dddd, [в] LT";
          case 1:
          case 2:
          case 4:
            return "[В прошлый] dddd, [в] LT";
          case 3:
          case 5:
          case 6:
            return "[В прошлую] dddd, [в] LT";
        }
      } else {
        if (this.day() === 2) {
          return "[Во] dddd, [в] LT";
        } else {
          return "[В] dddd, [в] LT";
        }
      }
    },
    sameElse: "L",
  },
});

let defaultFunction = function (app) {
  moment.locale("ru");
  app.config.globalProperties.$moment = moment;

  let momentFormat = (value = 0, format = "DD MMM Y HH:mm") => {
    if (value != null) {
      let $time = moment.utc(value).tz("Europe/Moscow").format(format);

      return $time;
    }
    return "";
  };

  let momentDuration = (value = 0, unit = "seconds") => {
    if (value != null) {
      let duration = moment.duration(value, unit);
      return duration ?? 0;
    }
    return "";
  };
  let momentDurationFormat = (value = 0, unit = "seconds", format) => {
    if (value != null) {
      if (value == 0) {
        return "0";
      }
      let duration = moment.duration(value, unit);

      return duration.format(format) ?? 0;
      //.format("D [days], H [hrs], m [mins], s [secs]");

      //return $time;
    }
    return "";
  };

  app.config.globalProperties.momentFormat = momentFormat;
  app.config.globalProperties.momentDuration = momentDuration;
  app.config.globalProperties.momentDurationFormat = momentDurationFormat;
};

export { defaultFunction as default };
